var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2844 16.2977L15.0542 13.0912C17.5763 9.86211 17.311 5.26331 14.412 2.36596C12.8856 0.840459 10.849 0 8.68139 0C6.5127 0 4.47712 0.840503 2.95076 2.36596C1.4243 3.89146 0.583313 5.92673 0.583313 8.093C0.583313 10.2603 1.42434 12.2946 2.95076 13.82C4.47721 15.3455 6.51376 16.186 8.68139 16.186C10.4741 16.186 12.2444 15.5891 13.6601 14.4609L16.8686 17.7123C17.0674 17.911 17.3112 18 17.5765 18C17.8419 18 18.0857 17.8894 18.2845 17.7123C18.6829 17.3366 18.6829 16.6956 18.2845 16.2974L18.2844 16.2977ZM14.789 8.09303C14.789 9.7291 14.1477 11.2555 12.9964 12.4052C11.8459 13.555 10.297 14.1968 8.68145 14.1968C7.06591 14.1968 5.51697 13.5559 4.36655 12.4052C3.21608 11.2555 2.57385 9.70756 2.57385 8.09303C2.57385 6.45696 3.2152 4.93053 4.36655 3.78083C5.51701 2.63109 7.06591 1.98926 8.68145 1.98926C10.3185 1.98926 11.8459 2.63021 12.9964 3.78083C14.1468 4.93144 14.789 6.45705 14.789 8.09303Z",
    fill: "#E2E8F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.67931c2cdf7535e4110d1c6fa3938ddd.svg";
export { ForwardRef as ReactComponent };